import { DataArchive } from './data-archive.js'
import { DataArchiveMutation } from './data-archive-mutation.js'
import { DataArchiveQuery } from './data-archive-query.js'

export const entities = [DataArchive]
export const resolvers = [DataArchiveQuery, DataArchiveMutation]
